import {isUnreadReady} from '../../../nova-invocation/novaInvocationStore';

// Where a task modal lands, decided once when the modal opens. `null` means "nothing about this
// task changes where it lands" - the regression case, a task with no Nova thread at all. 'unread'
// means the most recent answer has not been seen yet and should be brought into view. 'read' means
// it already has, and the composer should open straight into replying to it.
export type NovaLandingKind = 'unread' | 'read' | null;

// The single place this decision gets made. Reads novaInvocationStore's own read-state
// (isUnreadReady) rather than keeping a second notion of "read" here - that store is already the
// one place the Ready/Continue control on a task row answers the same question from, and a second,
// parallel answer could disagree with it.
//
// A task whose thread predates this browser session has no in-session record of ever being run, so
// isUnreadReady reads it the same as an already-seen answer (see novaInvocationStore's own note on
// hasEverRun). That is a known limit of the store this reuses, not something invented here - every
// other surface reading that same store lives with it too.
export function deriveNovaLandingKind(
	novaThread: ReadonlyArray<unknown> | null | undefined,
	taskId: string | null | undefined
): NovaLandingKind {
	const hasThread = Array.isArray(novaThread) && novaThread.length > 0;
	if (!hasThread || !taskId) return null;
	return isUnreadReady(taskId) ? 'unread' : 'read';
}
